<!-- <form [formGroup]="form" (ngSubmit)="onSubmit()">
  <textarea [froalaEditor]="options" formControlName="formModel"></textarea>
  <button type="submit">Submit</button>
</form> -->
<lib-enter-entities-relationship-details-library (dialogClose)="onDialogClose()"
 [primaryData]="primaryData"></lib-enter-entities-relationship-details-library>
